// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import {
  FLIGHT_TRAVEL,
  GROUND_TRAVEL,
  BUS_TRAVEL,
  LODGING_TRAVEL,
  Event,
  Passengers,
  TRAVEL,
} from './EventCategory';
import {
  getTimeWithOffset,
  getMilisecondsFromUTCTime,
  compinsateDst,
  getTimeWithoultOffset,
  generateEndTimeForGroundTransport,
} from '../../../infrastructure/utils/common';
import NoImage from '../../../NoImage.png';
import { images } from '../../../infrastructure/constants/common';

export function getEventByDto(eventDto, tz) {
  let estEvent = {
    ...eventDto,
    eventDate: getTimeWithOffset(
      moment(eventDto.startTime).tz(tz).format('YYYY-MM-DDTHH:mm:000Z')
    ),
    checkoutDate: getTimeWithOffset(
      moment(eventDto.endTime).tz(tz).format('YYYY-MM-DDTHH:mm:000Z')
    ),
    startTime: getMilisecondsFromUTCTime(
      moment(eventDto.startTime).tz(tz).hour(),
      moment(eventDto.startTime).tz(tz).minute()
    ),
    endTime: getMilisecondsFromUTCTime(
      moment(eventDto.endTime).tz(tz).hour(),
      moment(eventDto.endTime).tz(tz).minute()
    ),
  };
  if (
    eventDto.eventCategory === FLIGHT_TRAVEL ||
    eventDto.eventCategory === GROUND_TRAVEL ||
    eventDto.eventCategory === BUS_TRAVEL
  ) {
    if (!estEvent.eventLocationFrom) {
      estEvent = {
        ...estEvent,
        eventLocationFrom: { ...estEvent.passengers.locationFrom },
        eventLocationTo: { ...estEvent.passengers.locationTo },
      };
    }
  }
  if (eventDto.eventCategory === FLIGHT_TRAVEL) {
    estEvent = {
      ...estEvent,
      eventDate: getTimeWithOffset(
        moment(eventDto.startTime)
          .tz(eventDto.startTz)
          .format('YYYY-MM-DDTHH:mm:000Z')
      ),
      checkoutDate: getTimeWithOffset(
        moment(eventDto.endTime)
          .tz(eventDto.endTz)
          .format('YYYY-MM-DDTHH:mm:000Z')
      ),
      startTime: getMilisecondsFromUTCTime(
        moment(eventDto.startTime).tz(eventDto.startTz).hour(),
        moment(eventDto.startTime).tz(eventDto.startTz).minute()
      ),
      endTime: getMilisecondsFromUTCTime(
        moment(eventDto.endTime).tz(eventDto.endTz).hour(),
        moment(eventDto.endTime).tz(eventDto.endTz).minute()
      ),
    };
  }
  if (eventDto.timeTBD) {
    estEvent = {
      ...estEvent,
      startTime: -1,
      endTime: -1,
    };
  }
  if (eventDto.dateTBD) {
    estEvent = {
      ...estEvent,
      eventDate: undefined,
      checkoutDate: undefined,
    };
  }
  return estEvent;
}

export function getNewEvent(dayForAdd, tz, offset, membrs) {
  const evnt = new Event();
  if (dayForAdd === 'TBD') {
    evnt.dateTBD = true;
    evnt.timeTBD = true;
  } else {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    evnt.eventDate = getTimeWithOffset(
      moment(dayForAdd).tz(tz).format('YYYY-MM-DDTHH:mm:000Z')
    );
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    evnt.checkoutDate = getTimeWithOffset(
      moment(dayForAdd).tz(tz).format('YYYY-MM-DDTHH:mm:000Z')
    );
    evnt.startTime = -1;
    evnt.endTime = -1;
  }
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  evnt.passengers = new Passengers();
  const ev = {
    ...evnt,
    startTz: tz,
    startTimeOffset: offset,
    endTz: tz,
    endTimeOffset: offset,
    members: membrs.map(member => member.id),
    attendees: membrs.map(member => ({ id: member.id })),
  };
  return ev;
}

export function getEventDto(event, tz, duration) {
  if (event.startTime === -1 || event.endTime === -1) {
    // eslint-disable-next-line no-param-reassign
    event = {
      ...event,
      startTime: 0,
      endTime: 0,
    };
  }
  let utcEvent = { ...event };
  let date = new Date().toISOString();
  let chdate = new Date().toISOString();
  utcEvent = {
    ...utcEvent,
    startTime: compinsateDst(date, utcEvent.startTime, tz),
    endTime: compinsateDst(date, utcEvent.endTime, tz),
  };
  const ground =
    event.eventCategory === GROUND_TRAVEL || event.eventCategory === BUS_TRAVEL;
  if (utcEvent.eventType !== TRAVEL || ground) {
    if (
      utcEvent.eventDate === '' ||
      utcEvent.eventDate === null ||
      utcEvent.eventDate === undefined
    ) {
      utcEvent.dateTBD = true;
    } else {
      utcEvent.dateTBD = false;
      date = getTimeWithoultOffset(utcEvent.eventDate);
      utcEvent = {
        ...utcEvent,
        startTime: compinsateDst(date, event.startTime, tz),
        endTime: compinsateDst(date, event.endTime, tz),
      };
      if (ground) {
        utcEvent = {
          ...utcEvent,
          endTime: generateEndTimeForGroundTransport(
            utcEvent.startTime,
            tz,
            duration
          ),
        };
      }
    }
  } else {
    if (utcEvent.eventCategory === FLIGHT_TRAVEL) {
      utcEvent = {
        ...utcEvent,
        eventName: 'Flight',
      };
    }
    if (!utcEvent.timeTBD && !ground) {
      date = getTimeWithoultOffset(utcEvent.eventDate);
      chdate = getTimeWithoultOffset(utcEvent.checkoutDate);
      if (utcEvent.eventCategory === LODGING_TRAVEL) {
        utcEvent = {
          ...utcEvent,
          startTime: compinsateDst(date, event.startTime, tz),
          endTime: compinsateDst(chdate, event.endTime, tz),
        };
      }
      if (utcEvent.eventCategory === FLIGHT_TRAVEL) {
        utcEvent = {
          ...utcEvent,
          startTime: compinsateDst(date, event.startTime, utcEvent.startTz),
          endTime: compinsateDst(chdate, event.endTime, utcEvent.endTz),
        };
      }
    }
  }
  return utcEvent;
}

export function getTravelType(type) {
  return type === 'Arriving' ? 'Arriving' : 'Returning';
}

export function getEventImage(event, defaultImages) {
  if (event.customImageIsNotEmpty) {
    return event.customImageUrl;
  }

  if (event.defaultImageId) {
    return defaultImages.find(image => image.name === event.defaultImageId)
      ?.url;
  }

  if (event.imageUrl) {
    return event.imageUrl;
  }
  if (
    event.eventCategory !== 'Flight' &&
    event.image !== undefined &&
    event.image !== '' &&
    event.image !== null
  ) {
    return event.image.url;
  }
  if (
    event.eventCategory !== 'Flight' &&
    event.photoReference !== undefined &&
    event.photoReference !== '' &&
    event.photoReference !== null
  ) {
    return `https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&photoreference=
    ${event.photoReference}&key=AIzaSyBAAIr9HbcVCnLHgCw8WXXdLV47unpA_I8`;
  }
  if (event.assetImage) {
    return images[event.assetImage];
  }
  return NoImage;
}
